<!--
 * @Author: your name
 * @Date: 2021-06-30 20:00:25
 * @LastEditTime: 2021-09-27 10:59:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\pages\brandMall\addBrandMall.vue
-->
<template>
  <div>
    <div class="container">
      <div class="crumbs">
        <el-breadcrumb
          separator="/"
        >
          <el-breadcrumb-item>
            品牌商城基础信息管理
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div
        class="exclusive-top"
      >
        <p>
          <span>提示：</span>
          仅限法人信用认证与相应产品质量评价均达到B级以上的企业可申请
        </p>
      </div>
      <div
        class="content_form"
      >
        <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          label-width="150px"
          class="demo-formData"
        >
          <el-form-item
            label="店铺名称"
            prop="storeName"
          >
            <el-input
              v-model="
                formData.storeName
              "
              maxlength="12"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            label="认证品牌"
            prop="brandId"
          >
            <div class="flex">
              <div>
                <el-select
                  style="width:200px;margin-right:10px; "
                  v-model="
                    formData.brandId
                  "
                  placeholder="请选择认证品牌"
                  remote
                  filterable
                  @change="
                    brandChange
                  "
                  :remote-method="
                    getBrandList
                  "
                  :loading="
                    loading
                  "
                >
                  <el-option
                    v-for="item in brandList"
                    :value="
                      item.brandId
                    "
                    :label="
                      item.brandName
                    "
                    :key="
                      item.brandId
                    "
                  ></el-option>
                </el-select>
              </div>
              <div>
                <p
                  class="tips"
                  style="line-height: 18px;"
                >
                  请输入品牌名称进行查询，如果查询不到请申请品牌
                  点击
                  <el-button
                    type="text"
                    size="medium"
                    @click="
                      toPath
                    "
                  >
                    申请品牌
                  </el-button>
                  ，新标签页打开进入
                </p>
              </div>
            </div>
          </el-form-item>
          <p
            v-show="
              formData.brandId &&
                categoryList.length ==
                  0
            "
            class="tips-form"
          >
            您尚未申请所选品牌下的任何产品类目
          </p>
          <el-form-item
            label="品牌别名"
          >
            <el-input
              v-model="
                formData.brandAlias
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            label="品牌LOGO"
            prop="logoUrl"
          >
            <div
              class="upload-content"
            >
              <el-upload
                class="upload-logo"
                :show-file-list="
                  false
                "
                :headers="
                  headers
                "
                :before-upload="
                  beforeImgUpload
                "
                :action="
                  fileUploadForBrand
                "
                :on-success="
                  handleSuccess
                "
              >
                <img
                  v-if="
                    formData.logoUrl
                  "
                  :src="
                    formData.logoUrl
                  "
                  class="avatar"
                />
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
                <div
                  class="el-upload__tip"
                  slot="tip"
                  style="color:#999"
                >
                  高度上限150px，宽度上限270px，仅支持.jpg/.jpeg/.png格式，图片大小不超过500K
                </div>
              </el-upload>
              <div
                class="upload-text"
              >
                <el-popover
                  placement="right"
                  width="510"
                  trigger="hover"
                >
                  <p
                    class="logndemoImg"
                  >
                    <img
                      src="../../../../assets/img/common/logodemo1.png"
                      alt=""
                    />
                    <img
                      src="../../../../assets/img/common/logodemo2.png"
                      alt=""
                    />
                    <img
                      src="../../../../assets/img/common/logodemo3.png"
                      alt=""
                    />
                  </p>
                  <el-button
                    slot="reference"
                    type="text"
                  >
                    [图例]
                  </el-button>
                </el-popover>
              </div>
            </div>
          </el-form-item>

          <!-- <el-form-item v-if="pageType=='edit'" label="品牌商城产品目录" prop="categoryIds">
                    <div class="categoryList">
                         <div v-for="item in categoryList" :key="item.categoryId">
                            <p  v-if="formData.categoryIds.includes(item.categoryId)" >{{item.categoryName}}</p>
                         </div>
                    </div>
                </el-form-item>
                 <el-form-item v-else label="品牌商城产品目录" prop="categoryIds">
                    <el-select  style="width:100%" v-model="formData.categoryIds" multiple placeholder="请选择产品目录">
                        <el-option
                            v-for="item in categoryList"
                            :key="item.categoryId"
                            :label="item.categoryName"
                            :value="item.categoryId">
                        </el-option>
                    </el-select>
                </el-form-item> -->

          <el-form-item
            label="品牌商城产品目录"
            prop="categoryIds"
          >
            <el-select
              style="width:100%"
              v-model="
                formData.categoryIds
              "
              multiple
              placeholder="请选择产品目录"
            >
              <el-option
                v-for="item in categoryList"
                :key="
                  item.categoryId
                "
                :label="
                  item.categoryName
                "
                :value="
                  item.categoryId
                "
              ></el-option>
            </el-select>
          </el-form-item>

          <p
            class="tips-form"
          >
            品牌商城产品目录可多选，所选类目下的商品将会在品牌销售商城进行展示。
          </p>
          <el-form-item
            label="资质附件"
            prop="licenceUrl"
          >
            <div
              class="upload-content"
            >
              <el-upload
                class="upload-file"
                :headers="
                  headers
                "
                :action="
                  fileUploadForLicence
                "
                :on-success="
                  handleSuccess1
                "
                :on-remove="
                  handleRemove
                "
                :file-list="
                  fileList
                "
                :limit="1"
                :before-upload="
                  beforeImgUpload1
                "
              >
                <el-button
                  size="small"
                  type="primary"
                >
                  点击上传
                </el-button>
                <!-- <div class="el-upload__tip" slot="tip">仅支持 jpg/.jpeg/.png/.pdf格式，图片大小不超过2M</div> -->
              </el-upload>
              <!-- <div class="upload-text1"> 
                                <el-button @click="downloadFile" slot="reference" type="text">[点击下载易派客平台销售唯一授权证明]</el-button>
                            </div> -->
            </div>
            <div
              class="upload-text1"
            >
              企业自有品牌可上传“品牌所有证明”。若非自有品牌，请
              <span
                @click="
                  downloadFile
                "
              >
                [下载易派客平台销售唯一证明]
              </span>
              ，填写完毕并加盖公章之后，扫描上传。
              <!-- <el-button @click="downloadFile" slot="reference" type="text">[点击下载易派客平台销售唯一授权证明]</el-button> -->
            </div>
            <div
              class="upload-text2"
            >
              仅支持
              jpg/.jpeg/.png/.pdf格式，图片大小不超过2M
            </div>
          </el-form-item>
          <el-form-item
            label="商城有效期"
            prop="storeDeadline"
          >
            <el-date-picker
              :picker-options="
                pickerDateBefore
              "
              v-model="
                formData.storeDeadline
              "
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="联系人"
            prop="contact"
          >
            <el-input
              v-model="
                formData.contact
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系方式"
            prop="mobile"
          >
            <el-input
              v-model="
                formData.mobile
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            class="flex-c"
          >
            <el-button
              type="primary"
              plain
              @click="
                submitForm(
                  'formData',
                  'save'
                )
              "
            >
              保存
            </el-button>
            <el-button
              type="primary"
              @click="
                submitForm(
                  'formData',
                  'submit'
                )
              "
            >
              提交审核
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mallTypeList,
  CertificateOfAuthorization,
  epecToken,
} from "../../utils/globalData";

import Api from "../../api/product/index";
import userApi from "../../api/user/index";
import utils from "../../utils/utils";

export default {
  data() {
    return {
      headers: epecToken,
      fileUploadForBrand:
        userApi.fileUploadForBrand,
      fileUploadForLicence:
        userApi.fileUploadForLicence,

      mallTypeList,
      CertificateOfAuthorization,
      loading: false,
      formData: {
        temporaryId: "",
        storeName: "",
        brandId: "",
        brandName: "",
        brandAlias: "",
        logoUrl: "",
        licenceUrl: "",
        categoryIds: "",
        categoryString: "",
        storeDeadline: "",
        contact: "",
        mobile: "",
      },
      fileList: [],
      rules: {
        storeName: [
          {
            required: true,
            message:
              "请输入店铺名称",
            trigger: "blur",
          },
        ],
        brandId: [
          {
            required: true,
            message:
              "请选择品牌",
            trigger: "change",
          },
        ],

        logoUrl: [
          {
            required: true,
            message:
              "请上传品牌logo",
            trigger: "change",
          },
        ],
        categoryIds: [
          {
            required: true,
            message:
              "请选择产品目录",
            trigger: "blur",
          },
        ],
        licenceUrl: [
          {
            required: true,
            message:
              "请上传资质附件",
            trigger: "change",
          },
        ],
        storeDeadline: [
          {
            required: true,
            message:
              "请选择商城有效期",
            trigger: "change",
          },
        ],
        contact: [
          {
            required: true,
            message:
              "请输入联系人",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message:
              "请输入联系方式",
            trigger: "blur",
          },
        ],
      },
      brandList: [],
      categoryList: [],
      pageType: "",
      pickerDateBefore: {
        disabledDate(time) {
          return (
            time.getTime() <
            Date.now()
          );
        },
      },
    };
  },
  computed: {},
  created() {
    this.pageType = this.$route.query.type;
    if (
      this.pageType == "edit"
    ) {
      let info = this.$store
        .state.BRANDINfO;

      console.log(
        "info===。",
        JSON.parse(
          info.categoryNames
        )
      );
      console.log(
        "categoryIds===。",
        info.categoryIds
      );

      this.handlebrand(
        JSON.parse(
          info.categoryNames
        )
      );
      let categoryIds = info.categoryIds.split(
        ","
      );
      let ids = [];
      for (let i in categoryIds) {
        ids.push(
          parseInt(
            categoryIds[i]
          )
        );
      }
      this.fileList = JSON.parse(
        info.licenceUrl
      );
      this.formData = {
        temporaryId:
          info.temporaryId,
        storeStatus:
          info.storeStatus,
        storeName:
          info.storeName,
        brandId: info.brandId,
        brandName:
          info.brandName,
        brandAlias:
          info.brandAlias,
        logoUrl: info.logoUrl,
        licenceUrl:
          info.licenceUrl,
        categoryIds: ids,
        categoryString:
          info.categoryNames,
        storeDeadline:
          info.storeDeadline,
        contact: info.contact,
        mobile: info.mobile,
      };

      this.brandList = [
        {
          brandId:
            info.brandId,
          brandName:
            info.brandName,
        },
      ];
    }
  },
  methods: {
    //logo上传成功处理
    handleSuccess(res) {
      if (res.code == 200) {
        this.formData.logoUrl =
          res.data.url;
      }
    },
    handleSuccess1(res) {
      if (res.code == 200) {
        this.fileList.push({
          name:
            res.data.fileName,
          url: res.data.url,
        });
        this.formData.licenceUrl = JSON.stringify(
          this.fileList
        );
      }
    },
    handleRemove(
      file,
      fileList
    ) {
      console.log(
        "file",
        file
      );
      if (
        fileList.length == 0
      ) {
        this.formData.licenceUrl =
          "";
      }
      this.fileList = fileList;
    },
    async getBrandList(val) {
      if (val !== "") {
        this.loading = true;
        let parmas = {
          brandName: val,
          pageNum: 1,
          pageSize: 1000,
        };
        let res = await Api.queryBrandByName(
          parmas
        );
        if (res.code == 200) {
          this.loading = false;
          this.brandList =
            res.data.records;
        }
      } else {
        this.brandList = [];
      }
    },
    handlebrand(list) {
      let arr = [];
      list.forEach((item) => {
        let name = [];
        item.routeList.forEach(
          (route) => {
            name.push(
              route.categoryName
            );
          }
        );
        arr.push({
          categoryId:
            item.categoryId,
          categoryName: name.join(
            "/"
          ),
        });
        this.categoryList = arr;
      });
    },
    async brandChange() {
      let params = {
        brandId: this.formData
          .brandId,
      };
      this.formData.categoryIds = [];
      this.categoryList = [];
      let res = await Api.selectCategoryListByBrandId(
        params
      );
      if (res.code == 200) {
        let list = res.data;
        this.formData.categoryString = JSON.stringify(
          res.data
        );
        this.handlebrand(
          list
        );
      }
    },

    submitForm(
      formName,
      type
    ) {
      this.$refs[
        formName
      ].validate((valid) => {
        if (valid) {
          if (
            type == "save"
          ) {
            this.handleSave();
          } else if (
            type == "submit"
          ) {
            this.handleEdit();
          }
        } else {
          console.log(
            "error submit!!"
          );
          return false;
        }
      });
    },
    getParams() {
      let name = "";
      this.brandList.map(
        (item) => {
          if (
            this.formData
              .brandId ==
            item.brandId
          ) {
            name =
              item.brandName;
          }
        }
      );
      let params = {
        temporaryId: this
          .formData
          .temporaryId,
        storeName: this
          .formData.storeName,
        brandId: this.formData
          .brandId,
        brandName: name,
        brandAlias: this
          .formData
          .brandAlias,
        logoUrl: this.formData
          .logoUrl,
        licenceUrl: JSON.stringify(
          this.fileList
        ),
        categoryIds: this.formData.categoryIds.join(
          ","
        ),
        categoryNames: this
          .formData
          .categoryString,
        storeDeadline: this
          .formData
          .storeDeadline,
        contact: this.formData
          .contact,
        mobile: this.formData
          .mobile,
      };
      if (
        this.pageType !=
        "edit"
      ) {
        delete params.temporaryId;
      }

      return params;
    },

    async handleSave() {
      let params = this.getParams();
      let res = await userApi.saveStore(
        params
      );
      if (res.code == 200) {
        this.$message({
          message:
            "保存成功！",
          type: "success",
        });
        this.$router.push(
          "/brandMallMgt"
        );
      }
    },
    async handleEdit() {
      let params = this.getParams();
      let res = await userApi.submitStore(
        params
      );
      if (res.code == 200) {
        this.$message({
          message:
            "提交成功！",
          type: "success",
        });
        this.$router.push(
          "/brandMallMgt"
        );
      }
    },
    downloadFile() {
      window.open(
        this
          .CertificateOfAuthorization
      );
    },
    beforeImgUpload(file) {
      const isMaxsize =
        file.size / 1024 <
        500;
      let parmas = {
        file: file,
        typeArr: [
          "image/jpeg",
          "image/png",
        ],
        imgMessage:
          "上传图片只能是jpg或者png格式!",
        isMaxsize: isMaxsize,
        sizeMessage:
          "上传图片大小不能超过 500kb!",
        maxWidth: 270,
        maxHeight: 150,
      };
      return utils.checkImgupload(
        parmas
      );
    },
    beforeImgUpload1(file) {
      const isMaxsize =
        file.size /
          1024 /
          1024 <
        2;
      let parmas = {
        file: file,
        typeArr: [
          "image/jpeg",
          "image/png",
          "application/pdf",
        ],
        imgMessage:
          "上传文件只能是jpg、png或者pdf格式!",
        isMaxsize: isMaxsize,
        sizeMessage:
          "上传文件大小不能超过 2MB!",
        maxWidth: 10000,
        maxHeight: 10000,
      };
      return utils.checkImgupload(
        parmas
      );
    },
    toPath() {
      this.$router.push(
        "/brandProtocol"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/theme.scss";

.content_form {
  width: 830px;
  .upload-logo {
    ::v-deep .el-upload {
      width: 92px;
      height: 52px;
      line-height: 52px;
      border: 1px dashed
        #d9d9d9;
      border-radius: 5px;
      img {
        width: 90px;
        height: 50px;
      }
    }
  }
  .categoryList {
    height: 200px;
    overflow-y: auto;
    border: 1px solid #ccc;
    margin: 0 0 20px 0;
    padding: 10px;
    p {
      font-size: 12px;
      line-height: 20px;
      color: $c3;
    }
  }
}
.tips-form {
  font-size: 12px;
  height: 12px;
  line-height: 12px;
  color: red;
  text-align: left;
  margin: 0 0 8px 150px;
}
.tips-form::before {
  content: "*";
}
.exclusive-top {
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #e8efff;
  box-sizing: border-box;
  padding: 0 20px;
  margin: 20px 0;
  p {
    font-size: 16px;
    color: #333;
    span {
      color: #ef4c56;
      font-weight: bold;
    }
  }
}

.upload-content {
  position: relative;
  .upload-text {
    position: absolute;
    top: 28px;
    left: 100px;
    cursor: pointer;
    font-size: 14px;
  }
}
.upload-text1 {
  // position: absolute;
  // top:8px ;
  // left: 90px;
  font-size: 12px;
  color: #333;
  span {
    cursor: pointer;
    color: #2587ff;
  }
}
.upload-text2 {
  font-size: 12px;
  color: #333;
}
.logndemoImg {
  img {
    margin-right: 10px;
  }
}
</style>
